<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		name: 'App',
		components: {

		},
		data() {
			return {}
		},
		mounted() {
			if (!localStorage.getItem('language')) {
				localStorage.setItem('language', 'zh');
			}
			if (!localStorage.getItem('languageTow')) {
				localStorage.setItem('languageTow', 'zh_cn');
			}
			// 监听整个页面的双击事件
			document.addEventListener('dblclick', function(event) {
				// 阻止双击事件向上冒泡
				event.stopPropagation();
				return;
			})
		},
		methods: {

		}
	}
</script>

<style>
	body {
		margin: 0;
	}

	#app {
		width: 100%;
	}
</style>